import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiPatch, ApiError } from "../api/client";

interface ResetPinResponse {
  ok: boolean;
  code: "OK_WORKER_PIN_RESET";
}

export interface ResetPinPayload {
  worker_id: number;
  new_pin: string;
}

export function useResetPin() {
  const qc = useQueryClient();
  return useMutation<ResetPinResponse, ApiError, ResetPinPayload>({
    mutationFn: ({ worker_id, new_pin }) =>
      apiPatch(`/api/admin/workers/${worker_id}/pin`, { new_pin }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["workers"] }),
  });
}
